define((require) => {
    "use strict";

    const {Collection} = require("backbone");
    const RestApi = require("shared/services/RestApi");
    const CustomFontModel = require("editor/services/fonts/customFonts/CustomFontModel");

    return Collection.extend({

        model: CustomFontModel,

        comparator: (model) => -model.get("createdAt"),

        url: () => RestApi.pathToCollection(RestApi.Collections.FONTS)

    });
});



// WEBPACK FOOTER //
// ./src/editor/services/fonts/customFonts/CustomFontCollection.js